import {
    CREATE_EVENT, GET_EVENT,
    GET_EVENTS,
    SET_ALL_EVENTS, SET_ALL_EVENTS_SELECT, UPDATE_EVENT,SET_ALL_EVENTS_TITLES,

} from "../../reducerTypes";

const initialState = {
    getData: {},
    getList: [],
    selectData: [],
    getEventTitleList: [],
};

const eventReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ALL_EVENTS:
            return {
                ...state,
                getList: action.payload,
            };
        case SET_ALL_EVENTS_TITLES:
        return {
            ...state,
            getEventTitleList: action.payload,
        };
        case GET_EVENTS:
            return {
                ...state,
                getList: action.payload,
            };
        case SET_ALL_EVENTS_SELECT:
            const contentData = action.payload ? action.payload : [];
            const selectData = [];
            contentData.map((data) => {
                selectData.push({
                    value: data.id,
                    label: `${data.title}`,
                    labelEn: `${data.titleEn}`,
                    price: data.price,
                });
            });
            return {
                ...state,
                selectData: selectData,
            };
        case CREATE_EVENT:
            return {
                ...state,
                getData: action.payload,
            };
        case GET_EVENT:
            return {
                ...state,
                getData: action.payload,
            };
        case UPDATE_EVENT:
            return {
                ...state,
                getData: action.payload,
            };
        default:
            return state;
    }
};

export default eventReducer;
